import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"

export const setWorkingAttachmentRelation = createAsyncThunk(
	"workingArticleNoteRelation/setWorkingAttachmentRelation",
	async ({attachmentId, workspaceId},  {getState, rejectWithValue}) => {
		try {
			const state = getState()
			const userId = state.user?.value?.id

			const url = `/api/workspace/${workspaceId}/user/${userId}/attachment/${attachmentId}/note-relations`
			const { data } = await axios.get(url)
			return {relations: data, workspaceId}
		} catch (error) {
			console.error("Failed to set workspace attachment relation: ", error)
			return rejectWithValue("Something went wrong fetching attachment note relationships")
		}
	}
)

const initialValue = {
	articleId: -1,
	related: [],
	attached: [],
}

const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialValue)
export const workingArticleNoteRelationSlice = createSlice({
	name: "workingArticleNoteRelation",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		setWorkingArticleNoteRelation: (state, action) => {
			const {relations, workspaceId, articleId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.related = relations.related
			workspace.attached = relations.attached
			workspace.articleId = articleId
		},
		resetWorkingArticleNoteRelation: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.related = initialValue.related
			workspace.attached = initialValue.attached
			workspace.articleId = -1
		}
	},
	extraReducers: (builder) => {
		builder.addCase(
			setWorkingAttachmentRelation.fulfilled,
			workingArticleNoteRelationSlice.caseReducers.setWorkingArticleNoteRelation
		)
	}
})

export const {
	setWorkingArticleNoteRelation,
	resetWorkingArticleNoteRelation
} = workingArticleNoteRelationSlice.actions

export const selectWorkingArticleNoteRelation = (state, workspaceId) =>
	state.workingArticleNoteRelation.byWorkspace?.[workspaceId] ?? initialValue

export const setWorkingArticleNoteRelationAsync =
	(workspaceId, articleId) => async (dispatch) => {
		axios
			.get(`/api/workspace/${workspaceId}/article/${articleId}/note-relations`)
			.then(({ data }) => {
				dispatch(setWorkingArticleNoteRelation({relations: data, workspaceId, articleId}))
			})
	}

export default workingArticleNoteRelationSlice.reducer
